/* JETBLACK App — script រួម */
(function () {
  'use strict';

  /* ---- ប៊ូតុងថយក្រោយ៖ ថយតាមប្រវត្តិបើមកពីគេហទំព័រតែមួយ ---- */
  var back = document.querySelector('[data-app-back]');
  if (back) {
    back.addEventListener('click', function (e) {
      try {
        if (document.referrer && new URL(document.referrer).origin === location.origin && history.length > 1) {
          e.preventDefault();
          history.back();
        }
      } catch (err) {}
    });
  }

  /* ---- ផ្ទាំងគណនី៖ skeleton ពេលប្តូរ tab ----
     ផ្ទាំងនេះជារបស់ app OTP Plus SSO។ ពេលប្តូរ tab វាដាក់
     <p role="status">Loading orders…</p> ទុករង់ចាំប្រហែល ២ វិនាទី។

     ច្បាប់សំខាន់៖ កុំសរសេរជាន់ DOM របស់ app ដាច់ខាត។ ការសាកលើកមុន
     ខ្ញុំកំណត់ innerHTML ជំនួស ហើយ app បានរុះផ្ទាំងចោលទាំងស្រុង
     ក្នុងរយៈ ១ វិនាទី រួចបញ្ជូនអ្នកប្រើទៅទំព័រចូលរបស់ Shopify។
     ដូច្នេះយើងត្រឹមតែ បន្ថែម ធាតុមួយ ហើយលាក់អក្សរដើមដោយ CSS។ */
  (function () {
    var MAIN = '.otp-account-dashboard__main';
    var watchTimer = null;
    var mo = null;

    function rep(n, html) {
      var out = '';
      for (var i = 0; i < n; i++) out += html;
      return out;
    }

    /* app កំពុងផ្ទុក = មានតែ <p role="status"> ប៉ុណ្ណោះ (បូក skeleton យើង) */
    function statusOnly(main) {
      var kids = main.children;
      var status = null, others = 0;
      for (var i = 0; i < kids.length; i++) {
        var k = kids[i];
        if (k.tagName === 'P' && k.getAttribute('role') === 'status') status = k;
        else if (!k.classList.contains('otp-sk')) others++;
      }
      return others === 0 ? status : null;
    }

    function activeIndex() {
      var items = document.querySelectorAll('.otp-account-dashboard__nav-item');
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('otp-account-dashboard__nav-item--active')) return i;
      }
      return 0;
    }

    function markup() {
      var head =
        '<div class="sk sk-line--title" style="width:44%"></div>' +
        '<div class="sk sk-line sk-line--sm" style="width:60%"></div>';

      if (activeIndex() === 0) {
        return head +
          '<div class="otp-sk__grid">' +
          rep(4, '<div class="otp-sk__field">' +
                   '<div class="sk sk-line sk-line--sm" style="width:40%"></div>' +
                   '<div class="sk otp-sk__input"></div>' +
                 '</div>') +
          '</div>';
      }

      return head +
        rep(3, '<div class="otp-sk__card">' +
                 '<div class="otp-sk__row">' +
                   '<div class="sk sk-line" style="width:36%"></div>' +
                   '<div class="sk sk-pill"></div>' +
                 '</div>' +
                 '<div class="sk sk-line sk-line--sm" style="width:54%"></div>' +
                 '<div class="sk sk-line sk-line--sm" style="width:30%"></div>' +
               '</div>');
    }

    function clear(main) {
      var old = main.querySelector(':scope > .otp-sk');
      if (old) old.remove();
      main.classList.remove('otp-sk-on');
    }

    function paint(main) {
      if (main.querySelector(':scope > .otp-sk')) return;
      var d = document.createElement('div');
      d.className = 'otp-sk';
      d.setAttribute('aria-hidden', 'true');
      d.innerHTML = markup();
      /* បន្ថែមប៉ុណ្ណោះ — មិនប៉ះធាតុណាមួយរបស់ app ឡើយ */
      main.appendChild(d);
      main.classList.add('otp-sk-on');
    }

    function stop() {
      if (mo) { mo.disconnect(); mo = null; }
      clearTimeout(watchTimer);
    }

    function sync(main) {
      if (statusOnly(main)) paint(main);
      else clear(main);
    }

    function watch(tries) {
      var main = document.querySelector(MAIN);
      if (!main) {
        if (tries > 0) setTimeout(function () { watch(tries - 1); }, 120);
        return;
      }

      stop();
      sync(main);

      mo = new MutationObserver(function () {
        var m = document.querySelector(MAIN);
        if (!m) { stop(); return; }
        sync(m);
      });
      mo.observe(main, { childList: true });

      watchTimer = setTimeout(function () {
        var m = document.querySelector(MAIN);
        if (m) clear(m);
        stop();
      }, 15000);
    }

    /* បើកលើកដំបូង៖ ផ្ទាំងមិនទាន់មានពេលចុច។ ការត្រួតពិនិត្យរៀងរាល់
       ១២០ms អាចខកខានចន្លោះផ្ទុក ដូច្នេះឃ្លាំមើល body ដើម្បីចាប់
       វិនាទីដែលផ្ទាំងលេចចេញ រួចភ្ជាប់អ្នកឃ្លាំមើលពិតភ្លាម។ */
    function watchForOpen() {
      var bodyMo = new MutationObserver(function () {
        if (document.querySelector(MAIN)) { bodyMo.disconnect(); watch(0); }
      });
      bodyMo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { bodyMo.disconnect(); }, 6000);
      /* បើផ្ទាំងមានស្រាប់ (បើកឡើងវិញ) ចាប់ផ្តើមភ្លាម */
      if (document.querySelector(MAIN)) { bodyMo.disconnect(); watch(0); }
    }

    /* ---- ចូល/ចេញរួច ត្រូវផ្ទុកទំព័រឡើងវិញ ----
       app បិទផ្ទាំងរបស់វាបន្ទាប់ពី OTP ត្រឹមត្រូវ តែ HTML ដែល
       Shopify បង្ហាញរួចហើយនៅតែជាស្ថានភាពមិនទាន់ចូល។ ភ្ញៀវឃើញ
       ថាមិនទាន់ចូល រហូតទាល់តែ refresh ដោយដៃ។

       app រក្សា token ក្នុង localStorage។ ពេលតម្លៃនោះប្រែ មានន័យថា
       ស្ថានភាពចូលបានប្រែ — យើងផ្ទុកទំព័រឡើងវិញឲ្យស្វ័យប្រវត្តិ។
       ឃ្លាំមើលតែក្រោយពេលភ្ញៀវចុចប៊ូតុងគណនី ហើយធ្វើតែម្តងគត់។ */
    var TOKEN_KEY = 'otp_plus_nca_session_token';
    var authTimer = null;
    var reloaded = false;

    function token() {
      try { return localStorage.getItem(TOKEN_KEY); } catch (err) { return null; }
    }

    function loggedIn() {
      return !!(window.OTP_PLUS_CUSTOMER && window.OTP_PLUS_CUSTOMER.logged_in);
    }

    function watchAuth() {
      clearInterval(authTimer);
      var startToken = token();
      var startState = loggedIn();
      var deadline = Date.now() + 180000; /* OTP ចំណាយពេល — ឲ្យ ៣ នាទី */

      authTimer = setInterval(function () {
        if (reloaded) { clearInterval(authTimer); return; }
        if (Date.now() > deadline) { clearInterval(authTimer); return; }

        /* ការផ្ទុកទំព័រឡើងវិញត្រូវបានដកចេញទាំងស្រុង។
           Firebase (Google/Apple) បើក popup ហើយទំព័រមេត្រូវរស់នៅ
           ដើម្បីទទួលលទ្ធផល។ token អាចប្រែពាក់កណ្តាលផ្លូវ ហើយការ
           ផ្ទុកឡើងវិញត្រង់នោះកាត់ផ្តាច់ការចូល — ជាមូលហេតុ Google
           និង Apple វិលរហូតមិនឈប់។ ការចូលសំខាន់ជាងភាពស្រួល។ */
        if (token() !== startToken || loggedIn() !== startState) {
          reloaded = true;
          clearInterval(authTimer);
        }
      }, 400);
    }

    window.addEventListener('pagehide', function () { clearInterval(authTimer); });

    /* ---- បិទផ្ទាំង = ផ្ទុកទំព័រឡើងវិញ ----
       ការចូល និងការចេញ ទាំងពីរបញ្ចប់ត្រង់ការបិទផ្ទាំង។ ការតាមដាន
       token ឬ global មិនទុកចិត្តបាន ព្រោះ app មិនតែងតែធ្វើបច្ចុប្បន្នភាព
       វា។ ការផ្ទុកឡើងវិញរាល់ពេលបិទ ដោះស្រាយទាំងពីរម្តងតែម្តង៖
       ចូលរួច theme ឃើញភ្លាម · ចេញរួច app ចាប់ផ្តើមឡើងវិញ ដូច្នេះ
       ការចុចលើកក្រោយបើក OTP+ មិនរត់ទៅ Shopify ទៀត។ */
    var sheetWasOpen = false;

    /* «Charges may apply» ជា text node ទទេ គ្មាន element រុំ
       ដូច្នេះ CSS ចាប់មិនបាន ត្រូវដកតាម JS។ ដកតែពីរ node ចុងក្រោយ
       ដែលផ្គូផ្គងច្បាស់ មិនប៉ះអ្វីផ្សេង។ */
    function trimHelper() {
      var h = document.querySelector('.otp-helper');
      if (!h || h.dataset.jbTrim) return;
      var nodes = [].slice.call(h.childNodes);
      for (var i = nodes.length - 1; i >= 0; i--) {
        var n = nodes[i];
        if (n.nodeType === 3 && /charges may apply/i.test(n.textContent || '')) {
          n.parentNode.removeChild(n);
          continue;
        }
        if (n.nodeType === 1 && n.classList && n.classList.contains('otp-helper__dot')) {
          n.parentNode.removeChild(n);
          break;
        }
        break;
      }
      h.dataset.jbTrim = '1';
    }

    /* ---- កម្តៅបណ្តាញសម្រាប់ការចូលដោយ Google ----
       ការចូលដោយ Google របស់ app នេះដើរតាម Firebase Auth
       (signInWithPopup) ដែលត្រូវការ origin ថ្មីៗ ៥-៦ មុនចប់។
       លើ 4G origin ថ្មីនីមួយៗចំណាយ DNS + TCP + TLS ប្រហែល
       ០.៣-០.៨ វិនាទី មុនផ្ញើទិន្នន័យអ្វីទាល់តែសោះ។ Apple និង
       លេខទូរស័ព្ទប្រើ origin តែមួយ — នោះជាមូលហេតុវាលឿនជាង។

       យើងបើកការតភ្ជាប់ទុកជាមុន ខណៈផ្ទាំងចូលកំពុងបើក។ ពេលភ្ញៀវ
       អានរួចចុច Google ការតភ្ជាប់រួចរាល់ស្រាប់។ មិនធ្វើតាំងពី
       ផ្ទុកទំព័រទេ ព្រោះនោះនឹងធ្វើឲ្យហាងយឺតដោយឥតប្រយោជន៍។ */
    var warmed = false;

    function warmGoogle() {
      if (warmed) return;
      warmed = true;
      var hot = [
        'https://apis.google.com',
        'https://accounts.google.com',
        'https://identitytoolkit.googleapis.com',
        'https://securetoken.googleapis.com'
      ];
      var cool = [
        'https://firebaseinstallations.googleapis.com',
        'https://content-firebaseappcheck.googleapis.com',
        'https://www.google.com'
      ];
      hot.forEach(function (href) {
        var l = document.createElement('link');
        l.rel = 'preconnect';
        l.href = href;
        l.crossOrigin = '';
        document.head.appendChild(l);
      });
      cool.forEach(function (href) {
        var l = document.createElement('link');
        l.rel = 'dns-prefetch';
        l.href = href;
        document.head.appendChild(l);
      });
    }

    /* ---- បកប្រែអក្សរជាភាសាខ្មែរ ----
       អក្សរអង់គ្លេសទាំងនេះសរសេរដិតក្នុង app មិនមែនក្នុងការកំណត់ទេ
       ដូច្នេះប្តូរតាមផ្ទាំងគ្រប់គ្រងមិនបាន។ យើងប្តូរតម្លៃរបស់ text node
       ប៉ុណ្ណោះ — មិនបន្ថែម មិនលុប មិនរៀបធាតុឡើងវិញ — ដូច្នេះ
       ការយោងធាតុរបស់ app នៅដដែល ហើយវាដំណើរការធម្មតា។
       ប្តូរតែពេលអក្សរដូចបេះបិទ ដើម្បីកុំឲ្យប៉ះឈ្មោះ ឬអ៊ីមែលភ្ញៀវ។ */
    var KM = {
      /* ផ្ទាំងចូល */
      'Sign in to your account': 'ចូលគណនីរបស់អ្នក',
      "Choose how you'd like to continue": 'ជ្រើសរើសវិធីចូល',
      'Continue with Google': 'បន្តជាមួយ Google',
      'Continue with Apple': 'បន្តជាមួយ Apple',
      'or sign in with phone': 'ឬចូលដោយលេខទូរស័ព្ទ',
      'A 6-digit code will be sent via SMS': 'កូដ ៦ ខ្ទង់នឹងផ្ញើទៅតាម SMS',
      'Sign in with email': 'ចូលដោយអ៊ីមែល',
      'Sign in': 'ចូលគណនី',
      'Back': 'ត្រឡប់',

      /* ផ្ទាំងគណនី — ថេប */
      'Profile': 'ប្រវត្តិរូប',
      'Personal info': 'ព័ត៌មានផ្ទាល់ខ្លួន',
      'My Orders': 'ការបញ្ជាទិញ',
      'Order history': 'ប្រវត្តិបញ្ជាទិញ',
      'Addresses': 'អាសយដ្ឋាន',
      'Shipping & billing': 'ដឹកជញ្ជូន និងវិក្កយបត្រ',
      'Log Out': 'ចាកចេញ',
      'Logout': 'ចាកចេញ',

      /* ប្រវត្តិរូប */
      'Profile Details': 'ព័ត៌មានប្រវត្តិរូប',
      'Manage your personal information': 'គ្រប់គ្រងព័ត៌មានផ្ទាល់ខ្លួនរបស់អ្នក',
      'BASIC INFORMATION': 'ព័ត៌មានទូទៅ',
      'FIRST NAME': 'នាមខ្លួន',
      'LAST NAME': 'នាមត្រកូល',
      'EMAIL ADDRESS': 'អ៊ីមែល',
      'PHONE NUMBER': 'លេខទូរស័ព្ទ',
      'Edit': 'កែសម្រួល',
      'Save': 'រក្សាទុក',
      'Cancel': 'បោះបង់',

      /* ការបញ្ជាទិញ និងអាសយដ្ឋាន */
      'UNFULFILLED': 'មិនទាន់ដឹកជញ្ជូន',
      'FULFILLED': 'ដឹកជញ្ជូនរួច',
      'PARTIALLY_FULFILLED': 'ដឹកជញ្ជូនខ្លះ',
      'Add address': 'បន្ថែមអាសយដ្ឋាន',
      'Delete': 'លុប',
      'No orders yet': 'មិនទាន់មានការបញ្ជាទិញ',
      'No addresses yet': 'មិនទាន់មានអាសយដ្ឋាន',

      /* ស្ថានភាពកំពុងផ្ទុក (skeleton គ្របវាស្រាប់ តែបកទុកជាការការពារ) */
      'Loading profile…': 'កំពុងផ្ទុក…',
      'Loading orders…': 'កំពុងផ្ទុក…',
      'Loading addresses…': 'កំពុងផ្ទុក…'
    };

    /* ---- រុញ Log Out ចេញឆ្ងាយពីប៊ូតុងបិទ ----
       លើទូរស័ព្ទ app ដាក់វា ក្នុងកាតឈ្មោះ ជាប់នឹង ✕ ដូច្នេះ CSS
       តម្រៀបឡើងវិញមិនបាន — ត្រូវផ្លាស់ទីវាពិតប្រាកដ។
       appendChild ផ្លាស់ទីធាតុដដែល មិនបង្កើតថ្មី ដូច្នេះ event
       និងការយោងរបស់ app នៅដដែល។ ដាក់វាជាធាតុចុងក្រោយនៃរបារចំហៀង
       គឺនៅក្រោមថេប ឆ្ងាយពី ✕។ */
    function relocateLogout() {
      var side = document.querySelector('.otp-account-dashboard__sidebar');
      var out = document.querySelector('.otp-account-dashboard__logout');
      if (!side || !out) return;
      if (out.parentNode === side && side.lastElementChild === out) return;
      side.appendChild(out);
    }

    function translate(root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var n, hits = [];
      while ((n = walker.nextNode())) {
        var tag = n.parentNode && n.parentNode.nodeName;
        if (tag === 'SCRIPT' || tag === 'STYLE') continue;
        var t = n.nodeValue;
        var key = t.trim();
        if (!key || !KM[key]) continue;
        hits.push([n, t.replace(key, KM[key])]);
      }
      for (var i = 0; i < hits.length; i++) hits[i][0].nodeValue = hits[i][1];
    }

    setInterval(function () {
      var back = document.querySelector('.otp-account-modal-backdrop');
      if (back) {
        sheetWasOpen = true;
        translate(back);
        trimHelper();
        relocateLogout();
        /* បិទជាបណ្តោះអាសន្ន៖ preconnect ជាការបង្កើនល្បឿនតែប៉ុណ្ណោះ
           ហើយ Apple ចាប់ផ្តើមខូចក្នុងពេលដដែលដែលខ្ញុំដាក់វា។
           ការចូលសំខាន់ជាងល្បឿន — បើកវិញពេលដឹងច្បាស់ថាមិនពាក់ព័ន្ធ។ */
        /* if (document.querySelector('.otp-btn--google')) warmGoogle(); */
        return;
      }
      /* កុំផ្ទុកទំព័រឡើងវិញត្រង់នេះ។ ការបិទផ្ទាំងមិនមានន័យថាចប់ទេ —
         Firebase (Google/Apple) បើក popup ហើយទំព័រមេត្រូវរស់នៅ
         ដើម្បីទទួលលទ្ធផល។ ការផ្ទុកឡើងវិញកាត់ផ្តាច់វា ហើយការចូល
         បរាជ័យទាំងស្រុង។ ចំណែកលេខទូរស័ព្ទ ការផ្ទុកឡើងវិញលឿនពេក
         ធ្វើឲ្យ session មិនទាន់ត្រូវបានរក្សាទុក។
         ការតាមដានស្ថានភាពពិត (watchAuth) ទទួលបន្ទុកនេះជំនួស។ */
      sheetWasOpen = sheetWasOpen;
    }, 250);

    /* ---- ចុចប៊ូតុងគណនី ----
       តំណជា <a href="/account"> ធម្មតា។ បើ script របស់ OTP+ មិនទាន់
       រួចរាល់ browser ដើរតាមតំណភ្លាម ហើយភ្ញៀយត្រូវបានបញ្ជូនទៅទំព័រ
       ចូលដោយអ៊ីមែលរបស់ Shopify — មិនមែនអ្វីដែលយើងចង់បាន។

       ដូច្នេះយើងទប់តំណនោះ បើកសន្លឹករបស់យើងឡើងពីបាតភ្លាមជាមួយ
       skeleton រួចរង់ចាំ OTP+។ ពេលផ្ទាំងរបស់វាលេច យើងដកសន្លឹកយើងចេញ។
       តែបើ OTP+ ពិតជាមិនមក ទើបយើងបញ្ជូនទៅ /account ជាជម្រើសចុងក្រោយ។ */
    var sheet = null, sheetTimers = [], nudging = false;

    function appModalOpen() {
      return !!document.querySelector('.otp-account-modal-backdrop');
    }

    function closeSheet() {
      sheetTimers.forEach(clearTimeout);
      sheetTimers = [];
      if (sheet) { sheet.remove(); sheet = null; }
    }

    function openSheet() {
      if (sheet) return;
      sheet = document.createElement('div');
      sheet.className = 'jb-authsheet';
      sheet.setAttribute('aria-hidden', 'true');
      sheet.innerHTML =
        '<div class="jb-authsheet__panel"><div class="otp-sk">' +
        '<div class="sk sk-line--title" style="width:52%"></div>' +
        '<div class="sk sk-line sk-line--sm" style="width:68%"></div>' +
        '<div class="otp-sk__grid">' +
        rep(2, '<div class="otp-sk__field">' +
                 '<div class="sk sk-line sk-line--sm" style="width:44%"></div>' +
                 '<div class="sk otp-sk__input"></div>' +
               '</div>') +
        '</div>' +
        '<div class="sk sk-btn" style="margin-top:var(--s4)"></div>' +
        '</div></div>';
      document.body.appendChild(sheet);
    }

    function nudge(link) {
      if (appModalOpen()) { closeSheet(); return; }
      nudging = true;
      link.click();
      nudging = false;
    }

    function awaitOtp(link) {
      openSheet();

      var poll = setInterval(function () {
        if (appModalOpen()) { clearInterval(poll); closeSheet(); }
      }, 120);
      sheetTimers.push(poll);

      /* ប៉ុនប៉ងម្តងម្កាល — script អាចមកដល់យឺត */
      [300, 900, 2000, 4000].forEach(function (t) {
        sheetTimers.push(setTimeout(function () { if (!appModalOpen()) nudge(link); }, t));
      });

      /* ជម្រើសចុងក្រោយ បើ OTP+ មិនមកសោះ */
      sheetTimers.push(setTimeout(function () {
        clearInterval(poll);
        if (!appModalOpen()) {
          closeSheet();
          location.href = link.getAttribute('href') || '/account';
        }
      }, 10000));
    }

    document.addEventListener('click', function (e) {
      /* ប្តូរ tab — ផ្ទាំងមានស្រាប់ហើយ */
      if (e.target.closest('.otp-account-dashboard__nav-item')) { watch(0); return; }
      if (e.target.closest('[data-nav="account"]')) {
        var link = e.target.closest('[data-nav="account"]');
        watchForOpen();
        watchAuth();
        /* ទប់ការទៅ Shopify លុះត្រាតែយើងសម្រេចចិត្តខ្លួនឯង */
        if (!nudging && !appModalOpen()) {
          e.preventDefault();
          awaitOtp(link);
        }
        return;
      }
      /* ចេញពីគណនី ក៏ប្តូរស្ថានភាពដែរ */
      if (e.target.closest('.otp-account-dashboard__logout')) watchAuth();
      /* capture — app ហៅ stopPropagation លើតំណគណនី ដូច្នេះ listener
         ដំណាក់ bubble មិនដែលដល់វេនរត់ឡើយ */
    }, true);
  })();

  /* ---- សន្លឹកត្រូវតាមក្តារចុច ----
     នៅលើ iPhone ពេលក្តារចុចលេចឡើង visual viewport រួញតូច តែធាតុ
     position: fixed នៅតែធំតាមអេក្រង់ទាំងមូល។ ដូច្នេះសន្លឹករុញឡើងលើ
     ក្បាលត្រូវកាត់ ហើយផ្នែកខាងក្រោមទៅលាក់ក្រោយក្តារចុច។

     យើងវាស់កម្ពស់ក្តារចុចពី visualViewport រួចកំណត់សន្លឹកឲ្យស៊ី
     ត្រឹមផ្ទៃដែលនៅមើលឃើញ។ កែតែ style មិនប៉ះរចនាសម្ព័ន្ធ DOM
     របស់ app ឡើយ ដូច្នេះ app នៅដំណើរការធម្មតា។ */
  (function () {
    var vv = window.visualViewport;
    if (!vv) return;

    var SHEETS = '.otp-account-modal, .jb-authsheet__panel';
    var ticking = null;

    function sheets() { return document.querySelectorAll(SHEETS); }

    function clear(list) {
      for (var i = 0; i < list.length; i++) {
        if (!list[i].dataset.jbFit) continue;
        delete list[i].dataset.jbFit;
        list[i].style.removeProperty('bottom');
        list[i].style.removeProperty('height');
        list[i].style.removeProperty('max-height');
      }
    }

    /* iOS ពង្រីកទំព័ររាល់ពេលចុចចូលប្រអប់ដែលអក្សរតូចជាង 16px។
       ច្បាប់ CSS របស់យើងឈ្នះមិនបាន ព្រោះ stylesheet របស់ app
       ជា cross-origin ហើយច្បាប់វាមាន !important ដូចគ្នា។
       inline !important ជាអ្វីតែមួយគត់ដែលឈ្នះស្ថានភាពនេះ។ */
    function unzoom(root) {
      var f = root.querySelectorAll('input, select, textarea');
      for (var i = 0; i < f.length; i++) {
        if (f[i].dataset.jbUnzoom) continue;
        if (parseFloat(getComputedStyle(f[i]).fontSize) >= 16) continue;
        f[i].dataset.jbUnzoom = '1';
        f[i].style.setProperty('font-size', '16px', 'important');
      }
    }

    function fit() {
      var list = sheets();
      if (!list.length) return;

      if (window.innerWidth <= 749) {
        for (var n = 0; n < list.length; n++) unzoom(list[n]);
      }

      if (window.innerWidth > 749) { clear(list); return; }

      /* អ្វីដែលក្តារចុចស៊ីអស់ពីខាងក្រោម */
      var kb = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
      var h = Math.round(kb > 0 ? vv.height : vv.height * 0.88);

      for (var i = 0; i < list.length; i++) {
        var el = list[i];
        /* សរសេរតែពេលតម្លៃពិតជាប្រែ បើមិនដូច្នេះ browser គណនា
           style ឡើងវិញរាល់កន្លះវិនាទីដោយឥតប្រយោជន៍ */
        if (el.dataset.jbFit === kb + ':' + h) continue;
        el.dataset.jbFit = kb + ':' + h;
        el.style.setProperty('bottom', kb + 'px', 'important');
        el.style.setProperty('height', h + 'px', 'important');
        el.style.setProperty('max-height', h + 'px', 'important');
      }
    }

    function schedule() {
      clearTimeout(ticking);
      ticking = setTimeout(fit, 60);
    }

    vv.addEventListener('resize', schedule);
    vv.addEventListener('scroll', schedule);
    window.addEventListener('orientationchange', function () { setTimeout(fit, 260); });
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', function () { setTimeout(fit, 120); });

    /* សំណាញ់សុវត្ថិភាព — ថ្លៃតិច ព្រោះចេញភ្លាមបើគ្មានសន្លឹកបើក */
    setInterval(fit, 500);
  })();

  /* ---- Telegram៖ បើកកម្មវិធីផ្ទាល់ មិនមែនទំព័រ web ----
     iOS មិនគោរព universal link របស់ t.me ពីក្នុង app ដែល add to
     home screen ទេ — វាបើកកម្មវិធីរុករកក្នុងខ្លួនជំនួស។ ស្គីម tg://
     លោតចូល app តែម្តង តែវាត្រូវតែជាការចុចពិតរបស់អ្នកប្រើ។
     ការកំណត់ location.href ក្នុង handler ដោយខ្លួនឯង iOS មិនទទួល។
     ដូច្នេះយើងប្តូរ href របស់តំណនៅ pointerdown រួចទុកឲ្យ browser
     ដើរតាមវាដោយខ្លួនឯង — នោះជាការចុចពិត។

     មិនមានការត្រឡប់ទៅទំព័រ web ដោយស្វ័យប្រវត្តិទេ ព្រោះនោះនឹង
     ទាញកម្មវិធីយើងចេញពីទំព័របច្ចុប្បន្ន។ បើ Telegram មិនបើក
     យើងចាំយកឈ្នះស្ងាត់ៗ៖ ការចុចលើកក្រោយប្រើតំណ web ធម្មតាវិញ។

     ដើរគ្រប់ឧបករណ៍ — Telegram Desktop លើ Windows និង Mac
     ចុះឈ្មោះស្គីម tg:// ដូចគ្នា។ iPad ក៏ត្រូវការនេះដែរ ព្រោះ
     iPadOS ប្រាប់ខ្លួនជា Macintosh ដូច្នេះការពិនិត្យតាមឈ្មោះ
     ឧបករណ៍ចាប់វាមិនបានទេ។ */
  (function () {
    var tgFailed = false;

    function deepLink(url) {
      var m = url.pathname.match(/^\/(?:joinchat\/|\+)([\w-]+)\/?$/);
      if (m) return 'tg://join?invite=' + m[1];
      m = url.pathname.match(/^\/([A-Za-z]\w{3,})\/(\d+)\/?$/);
      if (m) return 'tg://resolve?domain=' + m[1] + '&post=' + m[2];
      m = url.pathname.match(/^\/([A-Za-z]\w{3,})\/?$/);
      if (m) return 'tg://resolve?domain=' + m[1];
      return null;
    }

    function swap(a) {
      if (tgFailed || !a || a.dataset.tgWeb) return null;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return null; }
      if (!/^(www\.)?(t|telegram)\.me$/i.test(url.hostname)) return null;

      var tg = deepLink(url);
      if (!tg) return null;

      a.dataset.tgWeb = a.href;
      a.dataset.tgTarget = a.target || '';
      a.href = tg;
      /* _blank ជាមួយ tg:// បើកកម្មវិធីរុករកទទេមួយ — យកចេញ */
      a.removeAttribute('target');
      return tg;
    }

    function restore(a) {
      if (!a || !a.dataset.tgWeb) return;
      a.href = a.dataset.tgWeb;
      if (a.dataset.tgTarget) a.setAttribute('target', a.dataset.tgTarget);
      delete a.dataset.tgWeb;
      delete a.dataset.tgTarget;
    }

    document.addEventListener('pointerdown', function (e) {
      swap(e.target.closest('a[href]'));
    }, { passive: true });

    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      /* ក្តារចុច ឬករណី pointerdown មិនកើត */
      if (!a.dataset.tgWeb) swap(a);
      if (!a.dataset.tgWeb) return;

      /* ស្តារតំណវិញភ្លាមក្រោយ browser ចាប់យក tg:// រួច */
      setTimeout(function () { restore(a); }, 0);

      /* បើ Telegram បើកមែន ទំព័រនេះលាក់ខ្លួន។ បើមិនលាក់ក្នុង ២
         វិនាទី មានន័យថាគ្មាន Telegram — លែងព្យាយាមតទៅទៀត។ */
      var left = false;
      function mark() { left = true; }
      /* ទូរស័ព្ទ៖ ទំព័រលាក់ខ្លួនពេលប្តូរទៅ app។
         កុំព្យូទ័រ៖ ទំព័រនៅឃើញដដែល តែផ្ទាំងបង្អួចបាត់ focus —
         ដូច្នេះត្រូវស្តាប់ blur ផងទើបដឹងថា Telegram Desktop បើក។ */
      document.addEventListener('visibilitychange', mark);
      window.addEventListener('pagehide', mark);
      window.addEventListener('blur', mark);
      setTimeout(function () {
        document.removeEventListener('visibilitychange', mark);
        window.removeEventListener('pagehide', mark);
        window.removeEventListener('blur', mark);
        if (!left && !document.hidden && document.hasFocus()) tgFailed = true;
      }, 2000);
    });
  })();

  /* ---- របារអូស៖ ព្រួញ + សញ្ញាចុច ---- */
  document.querySelectorAll('[data-rail]').forEach(function (rail) {
    var track = rail.querySelector('[data-rail-track]');
    if (!track) return;
    var prev = rail.querySelector('[data-rail-prev]');
    var next = rail.querySelector('[data-rail-next]');
    var dots = [].slice.call(rail.querySelectorAll('[data-rail-dot]'));

    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: 'smooth' }); });
    });

    function sync() {
      var i = Math.round(track.scrollLeft / step());
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft > track.scrollWidth - track.clientWidth - 4;
    }

    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 80); }, { passive: true });
    window.addEventListener('resize', sync);

    /* ទីតាំងចាប់ផ្តើម — ដើម្បីឲ្យមានកាតលេចពាក់កណ្តាលទាំងសងខាង
       តាំងពីបើកមក មិនមែនចាប់ពីកាតទី ១ ដែលឆ្វេងទទេ */
    var startAt = parseInt(rail.getAttribute('data-rail-start'), 10);
    var startLocked = false;

    function applyStart() {
      if (startLocked) return;
      if (!(startAt > 0 && track.children.length > startAt)) { startLocked = true; return; }
      var w = step();
      if (!w) return;
      /* track មាន scroll-behavior: smooth ដូច្នេះសូម្បីការកំណត់ដោយផ្ទាល់
         ក៏ animate ដែរ។ បិទវាបណ្តោះអាសន្នដើម្បីឲ្យទីតាំងដំបូងភ្លាម។ */
      var prev = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = startAt * w;
      track.style.scrollBehavior = prev;
      sync();
    }

    /* ដាក់ភ្លាម រួចម្តងទៀតពេលរូបភាពផ្ទុករួច ព្រោះទំហំអាចប្រែ។
       កុំប្រើ requestAnimationFrame — វាមិនរត់ក្នុង tab ដែលលាក់។ */
    applyStart();
    window.addEventListener('load', applyStart);
    setTimeout(applyStart, 200);

    /* ពេលអ្នកប្រើប៉ះរបារហើយ លែងរំកិលដោយខ្លួនឯងទៀត */
    track.addEventListener('pointerdown', function () { startLocked = true; }, { passive: true });
    setTimeout(function () { startLocked = true; }, 1200);

    sync();
  });

  /* ---- Loading អំឡុងពេលប្តូរទំព័រ ----
     បង្ហាញភ្លាមពេលចុច ខណៈ browser កំពុងទាញទំព័រថ្មី
     រួចលាក់ពេលទំព័រថ្មីលេចឡើង។ */
  (function () {
    var el = document.querySelector('[data-pageload]');
    if (!el) return;

    var safetyTimer = null;
    var armTimer = null;
    var body = document.querySelector('[data-pageload-body]');

    /* ពិត = យើងបានប្តេជ្ញាទៅទំព័រថ្មីហើយ កំពុងរង់ចាំវាមកដល់។
       ក្នុងអំឡុងនេះ គ្មានអ្វីត្រូវលាក់ skeleton ឡើយ — មិនមែន
       popstate មិនមែនការប្តូរទៅ app ផ្សេងរួចត្រឡប់មកវិញ។
       មានតែ pageshow ទេ ដែលជាសញ្ញាពិតថាទំព័រថ្មីមកដល់។ */
    var navigating = false;

    /* ស៊ុមរបស់ទំព័របច្ចុប្បន្ន ដើម្បីស្តារវិញពេលការចុចត្រូវបោះបង់ */
    var pageHasFab = document.body.classList.contains('has-backfab');
    var pageNav = (document.querySelector('.bottomnav__item.is-active') || {}).dataset;
    pageNav = pageNav ? pageNav.nav : null;

    /* skeleton ត្រូវបង្ហាញស៊ុមរបស់ទំព័រគោលដៅ មិនមែនរបស់ទំព័របច្ចុប្បន្ន។
       ឧ. ចេញពី collection ទៅ Home — Home គ្មានប៊ូតុងថយក្រោយ
       ដូច្នេះវាត្រូវបាត់ក្នុងអំឡុងពេលឆ្លង។ */
    function applyChrome(kind) {
      document.body.classList.toggle('has-backfab', kind !== 'index');
      var want = kind === 'index' ? 'index' : (kind === 'account' ? 'account' : null);
      document.querySelectorAll('.bottomnav__item[data-nav]').forEach(function (a) {
        a.classList.toggle('is-active', a.dataset.nav === want);
      });
    }

    function restoreChrome() {
      document.body.classList.toggle('has-backfab', pageHasFab);
      document.querySelectorAll('.bottomnav__item[data-nav]').forEach(function (a) {
        a.classList.toggle('is-active', a.dataset.nav === pageNav);
      });
    }

    /* រកប្រភេទទំព័រពី URL ដើម្បីបង្ហាញគ្រោងឲ្យត្រូវ */
    function kindOf(pathname) {
      var p = pathname.replace(/\/+$/, '') || '/';
      if (p === '/') return 'index';
      if (p.indexOf('/products/') !== -1) return 'product';
      if (p.indexOf('/collections') === 0) return 'collection';
      if (p.indexOf('/search') === 0) return 'search';
      if (p.indexOf('/cart') === 0) return 'cart';
      if (p.indexOf('/blogs/') === 0) {
        /* /blogs/<blog>/<article> = អត្ថបទ · /blogs/<blog> = បញ្ជី */
        return p.split('/').filter(Boolean).length >= 3 ? 'article' : 'blog';
      }
      if (p.indexOf('/pages/') === 0) return 'page';
      if (p.indexOf('/account') === 0) return 'account';
      if (p.indexOf('/gift_cards/') === 0) return 'gift_card';
      return 'other';
    }

    var painted = null;

    function paint(kind) {
      if (!body || painted === kind) return;
      painted = kind;
      var tpl = document.querySelector('template[data-sk="' + kind + '"]');
      if (!tpl) tpl = document.querySelector('template[data-sk="other"]');
      if (!tpl) return;
      body.replaceChildren(tpl.content.cloneNode(true));
    }

    function show(kind, withChrome) {
      clearTimeout(safetyTimer);

      /* ដាក់ class មុនគេ ដើម្បីឲ្យ browser គូរបានឆាប់បំផុត */
      el.classList.add('is-on');
      if (kind) paint(kind);

      /* ការប្តូរ class លើ body នៅ pointerdown អាចធ្វើឲ្យ browser
         បោះបង់ការចុច ដូច្នេះធ្វើវាតែពេល click ដែលការ navigate ច្បាស់ */
      if (kind && withChrome) applyChrome(kind);

      /* បើមាន panel បើកនៅលើទំព័រ (sub category ឬ side menu) វាមាន
         z-index ខ្ពស់ជាងរបាំង ដូច្នេះ skeleton លាក់នៅពីក្រោយ។
         ករណីនោះ លើករបាំងឲ្យខ្ពស់ជាង រួចដាក់មកវិញពេលលាក់។ */
      /* side menu នៅ z-index 200 ដូច្នេះនៅត្រូវលើករបាំង។
         Panel sub category ចុះមក 40 ហើយ ដូច្នេះមិនចាំបាច់ទេ។ */
      var covering = document.querySelector('.sidemenu.is-open');
      el.style.zIndex = covering ? '201' : '';
      document.body.classList.toggle('pl-over', !!covering);

      /* អាន offsetHeight ដើម្បីបង្ខំ browser គូរវាមុនចាកចេញ */
      void el.offsetHeight;

      if (withChrome) navigating = true;

      /* បើទាញយូរពេក ឬអ្នកប្រើបោះបង់ កុំឲ្យវាជាប់។
         ១០ វិនាទី ព្រោះ 4G នៅហាងអាចយឺតជាង ៥ វិនាទី ហើយបើ
         skeleton បាត់ខណៈទំព័រនៅមកមិនទាន់ដល់ អេក្រង់មើលទៅដូចគាំង។ */
      safetyTimer = setTimeout(hide, 10000);
    }

    function hide() {
      navigating = false;
      clearTimeout(safetyTimer);
      el.classList.remove('is-on');
      el.style.zIndex = '';
      document.body.classList.remove('pl-over');
      restoreChrome();
    }

    function isPlainLeftClick(e) {
      return !e.defaultPrevented && e.button === 0 &&
        !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
    }

    /* តំណនេះនឹងផ្ទុកទំព័រថ្មីមែនទេ? ត្រឡប់ kind ឬ null */
    function targetKind(a) {
      if (!a || a.hasAttribute('download')) return null;
      if (a.target && a.target !== '_self') return null;

      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return null;
      if (/^(mailto:|tel:|sms:|javascript:)/i.test(href)) return null;

      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return null; }
      if (url.origin !== location.origin) return null;

      /* តំណទៅកន្លែងតែមួយ (ត្រឹមតែ hash) មិនផ្ទុកទំព័រថ្មីទេ */
      if (url.pathname === location.pathname && url.search === location.search && url.hash) return null;

      return kindOf(url.pathname);
    }

    /* បង្ហាញភ្លាមពេលម្រាមដៃប៉ះ មិនរង់ចាំដល់លែង។
       pointerdown មកមុន click ប្រហែល 100-300ms — នោះជាចន្លោះ
       ដែលធ្វើឲ្យវាមានអារម្មណ៍ភ្លាមៗ ជាពិសេសពេលបើកជា app លើ
       home screen ដែលគ្មានរបារ browser បង្ហាញថាកំពុងផ្ទុក។ */
    var armed = false, armX = 0, armY = 0, cancelTimer = null;

    function disarm() { armed = false; clearTimeout(cancelTimer); clearTimeout(armTimer); }


    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var kind = targetKind(e.target.closest('a'));
      if (kind === null) return;

      /* កុំបង្ហាញមុនកាលក្នុងម៉ឺនុយចំហៀង។
         របាំង skeleton លើកខ្លួនទៅ z-index 201 ដើម្បីគ្របម៉ឺនុយ (200)។
         ការដាក់ស្រទាប់ថ្មីលើធាតុដែលម្រាមដៃកំពុងប៉ះ ធ្វើឲ្យ iOS
         លុបចោលការចុច — skeleton លោតមួយភ្លែត រួចបាត់ ហើយទំព័រ
         មិនប្តូរ។ កន្លែងផ្សេងគ្មានបញ្ហា ព្រោះ skeleton នៅ z-index 50
         គឺក្រោមមាតិកាដែលចុច។
         ក្នុងម៉ឺនុយ យើងរង់ចាំការចុចពិត — វាលឿនល្មមរួចទៅហើយ។ */
      if (e.target.closest('.sidemenu')) return;

      /* សម្អាត timer ចាស់ទាំងអស់មុនចាប់ផ្តើមថ្មី។ cancelTimer ពី
         ការចុចមុន (៤០០ms) អាចបាញ់ចំកណ្តាលការចុចនេះ ហើយហៅ
         disarm() + hide() — នោះជាមូលហេតុដែលការចុចលឿនៗ
         ជាប់ៗគ្នា ធ្វើឲ្យ skeleton លែងលោតម្តងម្កាល។ */
      clearTimeout(cancelTimer);
      clearTimeout(safetyTimer);
      clearTimeout(armTimer);
      cancelTimer = safetyTimer = null;

      armed = true; armX = e.clientX; armY = e.clientY;

      /* គូរ skeleton ចូល DOM តាំងពីឥឡូវ តែមិនទាន់បង្ហាញ។
         ការងារធ្ងន់ (សាង DOM + layout) ធ្វើរួចនៅទីនេះ ដូច្នេះពេល
         បង្ហាញ browser គ្រាន់តែបើកភ្លើង — គូរបានទាន់មុនចាកចេញ។
         មិនបង្ហាញភ្លាមទេ ព្រោះការ scroll ចាប់ផ្តើមលើតំណ
         ហើយបង្ហាញរួចដករំពេចធ្វើឲ្យអេក្រង់ភ្លឹបៗ។ */
      paint(kind);

      armTimer = setTimeout(function () {
        if (armed) show(kind, false);
      }, 80);
    }, { passive: true });

    /* បើអូស ឬរំកិល នោះមិនមែនការចុចទេ */
    document.addEventListener('pointermove', function (e) {
      if (!armed) return;
      if (Math.abs(e.clientX - armX) > 8 || Math.abs(e.clientY - armY) > 8) { disarm(); hide(); }
    }, { passive: true });

    document.addEventListener('pointercancel', function () { disarm(); hide(); }, { passive: true });

    /* ការ scroll ចាប់ផ្តើម = មិនមែនការចុចទេ */
    window.addEventListener('scroll', function () {
      if (armed) { disarm(); hide(); }
    }, { passive: true });

    /* លែងម្រាមដៃ តែគ្មាន click តាមក្រោយ = បោះបង់ */
    document.addEventListener('pointerup', function () {
      if (!armed) return;
      clearTimeout(cancelTimer);
      cancelTimer = setTimeout(function () { disarm(); hide(); }, 400);
    }, { passive: true });

    /* click នៅតែជាទីពឹង សម្រាប់ក្តារចុច និងករណី pointerdown មិនកើត */
    document.addEventListener('click', function (e) {
      if (!isPlainLeftClick(e)) { disarm(); hide(); return; }
      var kind = targetKind(e.target.closest('a'));
      if (kind === null) { disarm(); hide(); return; }
      disarm();
      show(kind, true);
    });

    document.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      var f = e.target;
      if (f && f.target && f.target !== '_self') return;
      var act = f.getAttribute('action') || location.pathname;
      var k = 'other';
      try { k = kindOf(new URL(act, location.href).pathname); } catch (err) {}
      show(k, true);
    });

    /* refresh ឬវាយ URL ដោយផ្ទាល់ */
    window.addEventListener('beforeunload', function () { show(); });

    /* លាក់ភ្លាមពេលទំព័រថ្មីលេចឡើង រួមទាំងពេលថយក្រោយពី bfcache */
    /* bfcache ស្តារទំព័រមកវិញដោយ JavaScript មិនរត់ឡើងវិញ៖ អថេរ និង
       timer ទាំងអស់នៅដដែលពីមុនចាកចេញ។ timer ចាស់ដែលបាញ់ក្រោយមក
       អាចហៅ hide() ឬ disarm() ចំពេលកំពុងចុច ដែលធ្វើឲ្យ skeleton
       លែងដើរ ហើយមិនទៀងទាត់។ ត្រូវសម្អាតទាំងស្រុងរាល់ពេលទំព័រលេចឡើង។ */
    function resetAll() {
      clearTimeout(safetyTimer);
      clearTimeout(armTimer);
      clearTimeout(cancelTimer);
      safetyTimer = armTimer = cancelTimer = null;
      armed = false;
      navigating = false;
      painted = null;
      el.classList.remove('is-on');
      el.style.zIndex = '';
      document.body.classList.remove('pl-over');
      restoreChrome();
    }

    /* pageshow ជាសញ្ញាតែមួយគត់ដែលទុកចិត្តបានថាទំព័រថ្មីមកដល់ */
    window.addEventListener('pageshow', resetAll);

    /* panel sub category ប្រើ history.pushState ដូច្នេះ popstate
       បាញ់រាល់ពេលបិទ panel។ បើយើង reset ដោយមិនគិត វានឹងលុប
       skeleton របស់ការទៅទំព័រថ្មីដែលកំពុងដំណើរការ។ */
    window.addEventListener('popstate', function () {
      if (!navigating) resetAll();
    });

    /* ត្រឡប់មកមើលទំព័រវិញពី app ផ្សេង ក៏សម្អាតដែរ — លើកលែងតែ
       កំពុងទៅទំព័រថ្មី។ iOS បាញ់ព្រឹត្តិការណ៍នេះពេលប្តូរ app ហើយ
       ការចុចលឿនៗអាចធ្វើឲ្យវាបាញ់ចំពេលទំព័រថ្មីកំពុងមក។ */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && !armed && !navigating) resetAll();
    });
  })();

  /* ---- Side menu ---- */
  (function () {
    var menu = document.querySelector('[data-sidemenu]');
    if (!menu) return;
    var panel = menu.querySelector('.sidemenu__panel');
    var opener = document.querySelector('[data-sidemenu-open]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      menu.hidden = false;
      /* បង្ខំឲ្យ browser គិត layout មុន ដើម្បីឲ្យ transition រត់ */
      void menu.offsetWidth;
      menu.classList.add('is-open');
      document.body.classList.add('is-locked');
      document.body.style.overflow = 'hidden';
      var first = panel.querySelector('.sidemenu__close');
      if (first) first.focus();
    }

    function close() {
      menu.classList.remove('is-open');
      document.body.classList.remove('is-locked');
      document.body.style.overflow = '';
      var done = function () { menu.hidden = true; };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { done(); }
      else { setTimeout(done, 400); }
      if (lastFocus) lastFocus.focus();
    }

    if (opener) opener.addEventListener('click', open);

    menu.addEventListener('click', function (e) {
      if (e.target.closest('[data-sidemenu-close]')) { e.preventDefault(); close(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
    });

    /* រក្សា focus ក្នុង panel */
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var items = panel.querySelectorAll('a[href], button, summary');
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* អូសទៅឆ្វេងដើម្បីបិទ */
    var x0 = null;
    panel.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    panel.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (dx < -60) close();
      x0 = null;
    }, { passive: true });
  })();

  /* ---- Hero slider៖ រំកិលស្វ័យប្រវត្តិ + ព្រួញ + សញ្ញាចុច ---- */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var track = hero.querySelector('[data-hero-track]');
    if (!track) return;

    var slides = [].slice.call(track.children);
    if (!slides.length) return;

    var dots = [].slice.call(hero.querySelectorAll('[data-hero-dot]'));
    var prev = hero.querySelector('[data-hero-prev]');
    var next = hero.querySelector('[data-hero-next]');
    var delay = parseInt(hero.getAttribute('data-hero-delay'), 10) || 0;
    var loop = hero.getAttribute('data-hero-loop') === 'true';
    var timer = null;
    var paused = false;

    function step() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slides[0].getBoundingClientRect().width + gap;
    }

    function index() {
      return Math.round(track.scrollLeft / step());
    }

    function goTo(i, smooth) {
      track.scrollTo({ left: i * step(), behavior: smooth === false ? 'auto' : 'smooth' });
    }

    function advance(dir) {
      var i = index() + dir;
      if (i >= slides.length) i = loop ? 0 : slides.length - 1;
      if (i < 0) i = loop ? slides.length - 1 : 0;
      goTo(i);
    }

    function sync() {
      var i = index();
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (!loop) {
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= slides.length - 1;
      }
    }

    function start() {
      stop();
      if (!delay || reduce || slides.length < 2) return;
      timer = setInterval(function () {
        if (paused || document.hidden) return;
        advance(1);
      }, delay);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    /* ផ្អាកពេលអ្នកប្រើកំពុងប៉ះ ឬដាក់ cursor លើវា */
    ['pointerenter', 'focusin'].forEach(function (ev) {
      hero.addEventListener(ev, function () { paused = true; });
    });
    ['pointerleave', 'focusout'].forEach(function (ev) {
      hero.addEventListener(ev, function () { paused = false; });
    });
    track.addEventListener('pointerdown', function () { paused = true; });
    window.addEventListener('pointerup', function () {
      setTimeout(function () { paused = false; }, 600);
    });

    if (prev) prev.addEventListener('click', function () { advance(-1); start(); });
    if (next) next.addEventListener('click', function () { advance(1); start(); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i); start(); });
    });

    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(sync, 80);
    }, { passive: true });

    window.addEventListener('resize', function () { goTo(index(), false); sync(); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    sync();
    start();
  });
})();
